import styled from "styled-components";
import TopNavBarComponent from "../components/nav/TopNavBarComponent";
import { OutlineCard } from "../components/Components";
import { Link } from "react-router-dom";

const Container = styled.div`
	position: relative;
`;

const TutorialBody = styled.div`
	position: relative;
	max-width: 800px;
	margin: 0 auto;
	padding: 24px 0;
`;

const TutorialCardContainer = styled.div`
	display: flex;
	flex-wrap: wrap;
	justify-content: center;
	gap: 24px;
	margin-top: 48px;
`;

const TutorialCard = styled(OutlineCard)`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	min-width: 250px;
	min-height: 200px;
	gap: 12px;
	text-decoration: none;

	span {
		width: 36px;
		height: 36px;
		font-size: 36px;
		line-height: 36px;
		text-decoration: none;
	}

	h3 {
		color: var(--color-on-surface);
		text-decoration: none;
	}
`;

export default function TutorialPage() {
	return (
		<Container>
			<TopNavBarComponent
				goBack={false}
				centredTitle={true}
				title="Tutorial"
			/>
			<TutorialBody>
				<p>
					In questa pagina puoi trovare vari tutorial che ti spiegano
					come utilizzare correttamente l'app e come eseguire diverse
					operazioni a casa.
				</p>
				<TutorialCardContainer>
					<Link to="/app/tutorial/prenotazione" style={{textDecoration: "none"}}>
						<TutorialCard>
							<span className="material-symbol fill">
								bookmark
							</span>
							<h3>Prenotazione</h3>
						</TutorialCard>
					</Link>
					<Link to="/app/tutorial/arrivo" style={{textDecoration: "none"}}>
						<TutorialCard>
							<span className="material-symbol fill">login</span>
							<h3>Arrivo</h3>
						</TutorialCard>
					</Link>
					<Link to="/app/tutorial/partenza" style={{textDecoration: "none"}}>
						<TutorialCard>
							<span className="material-symbol fill">logout</span>
							<h3>Partenza</h3>
						</TutorialCard>
					</Link>
					<Link to="/app/tutorial/camino_e_stufe" style={{textDecoration: "none"}}>
						<TutorialCard>
							<span className="material-symbol fill">
								local_fire_department
							</span>
							<h3>Camino e stufe</h3>
						</TutorialCard>
					</Link>
					<Link to="/app/tutorial/acqua" style={{textDecoration: "none"}}>
						<TutorialCard>
							<span className="material-symbol fill">shower</span>
							<h3>Acqua</h3>
						</TutorialCard>
					</Link>
					<Link to="/app/tutorial/casa" style={{textDecoration: "none"}}>
						<TutorialCard>
							<span className="material-symbol fill">
								cottage
							</span>
							<h3>Casa</h3>
						</TutorialCard>
					</Link>
				</TutorialCardContainer>
			</TutorialBody>
		</Container>
	);
}
